import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const OpportunityDocumentListDetails = () => {
    const columns = [
        { label: 'Document Name', value: 'name' },
        { label: 'Description', value: 'description' },
        { label: 'Upload Date', value: (item) => fmtDate(item.upload_date) },
        { label: 'Opportunity Name', value: (document) => document.opportunity.opportunity_name },  // Assuming opportunity is nested in document data

    ];

    const handleViewDocument = (documentId) => {
        // Handle viewing the document details (navigating to the details page)
        //console.log('View Document', documentId);
        const encodedId = btoa(documentId);
        window.location.href = `/opportunity-document/details/${encodedId}`;
    };

    return (
        <div>
            <h1>Opportunity Documents</h1>
            <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES.opportunityDocument} columns={columns} />
        </div>
    );
};

export default OpportunityDocumentListDetails;
